export default __webpack_public_path__ + "static/worldmap-b062587dbf9036720b4c472aafa234dc.png";